import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { updateExportFailed, updateExportSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* updateExport(action) {
  try {
    const { pool, id } = action.payload;
    const url = `${BACKEND_URL}/api/v1/uploader/${id}`;
    const dataResponse = yield makeRequest(url, pool, action, 'PUT', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(updateExportSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(updateExportFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(updateExportFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
